import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ROUTES_CONSTANT } from './@shared/constants/Routes.constant';

@NgModule({
  imports: [RouterModule.forRoot(ROUTES_CONSTANT, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
